/**
 * Increment session games-played counts and win/loss streaks after a single scored game.
 * Mirrors fetchGamesPlayedCount logic in CompetitiveSessionPage for one game.
 */

function defaultStreakEntry() {
  return {
    wins: 0,
    losses: 0,
    currentWinStreak: 0,
    currentLossStreak: 0,
  };
}

/**
 * @param {Record<string, number>} prevCounts
 * @param {Record<string, object>} prevStreaks
 * @param {{ team1: string[], team2: string[], winningTeam: number|null }} game
 * @returns {{ gamesPlayedCount: Record<string, number>, playerStreaks: Record<string, object> }}
 */
export function incrementGamesPlayedAndStreaks(prevCounts, prevStreaks, game) {
  const team1 = game?.team1 || [];
  const team2 = game?.team2 || [];
  const winningTeam = game?.winningTeam ?? null;

  const gamesPlayedCount = { ...(prevCounts || {}) };
  const playerStreaks = { ...(prevStreaks || {}) };

  const applyForTeam = (playerIds, teamNumber) => {
    playerIds.filter(Boolean).forEach((playerId) => {
      gamesPlayedCount[playerId] = (gamesPlayedCount[playerId] || 0) + 1;

      if (!playerStreaks[playerId]) {
        playerStreaks[playerId] = defaultStreakEntry();
      } else {
        playerStreaks[playerId] = { ...playerStreaks[playerId] };
      }

      const won =
        winningTeam != null &&
        ((winningTeam === 1 && teamNumber === 1) || (winningTeam === 2 && teamNumber === 2));

      if (won) {
        playerStreaks[playerId].wins += 1;
        playerStreaks[playerId].currentWinStreak += 1;
        playerStreaks[playerId].currentLossStreak = 0;
      } else if (winningTeam != null) {
        playerStreaks[playerId].losses += 1;
        playerStreaks[playerId].currentLossStreak += 1;
        playerStreaks[playerId].currentWinStreak = 0;
      }
    });
  };

  applyForTeam(team1, 1);
  applyForTeam(team2, 2);

  return { gamesPlayedCount, playerStreaks };
}
